module.exports = __webpack_public_path__ + "static/scruggsheadshot-a04deff55600be77c4ca8a0de7b74792.jpg";